import React from 'react'
import Form from "../../Forms/Containers/FormCreator";

import { indivdualObject } from './IndividualObject'


class IndividualComponent extends React.Component {
  state = {
    object: [],
    // cantVictims: 0
  }
  async componentDidMount() {
    const object = await indivdualObject(this.props)
    this.setState({ object })
    this.props.startMap()
  }

  // componentDidUpdate() {
  //   console.log(this.props, this.state)
  //   if (this.props.values.victims !== undefined && this.props.values.victims.length !== this.state.cantVictims) {
  //     const object = this.state.object.map((item) => {
  //         return item
  //         if (item.variable === 'showVicts') {
  //         return {
  //           ...item,
  //           value: (
  //             <div className="line line-100 text-center" >                
  //               Otro tales
  //             </div>
  //           )
  //         }
  //       } else {
  //         return item
  //       }
  //     })
  //     console.log(object)
  //     this.setState({ object, cantVictims: this.props.victims.length })
  //   }
  // }

  render() {
    return (
      <div className="background-body">
        <div className="container-content">
          <div className="content-line">
            <Form
              onChange={this.props.onChange}
              objectCreator={this.state.object}
              onSubmit={this.props.onSubmit}
              values={this.props.values}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default IndividualComponent
